export const NotificationsStatsigFeatureGate = {
  PushNotificationCenter: 'push_notification_center',
  NotificationSettings: 'push_notification_settings',
} as const
